// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ac64c6e8","885":"fc9c31ce","977":"8119ae3a"}[chunkId] + ".chunk.js";
};